<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions">
    <app-anillo-perfil class="relative" style="--anillo-separacion: -3px; --anillo-grosor: 2px"
                       [porcentaje]="(progresoPerfil$ | async)?.porcentaje ?? null">
        @if (showAvatar && user?.avatar) {
            <img class="h-7 w-7 rounded-full" [src]="user.avatar" />
        }
        @if (!showAvatar || !user?.avatar) {
            <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        }
    </app-anillo-perfil>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>{{ 'userMenu.signedInAs' | transloco }}</span>
            <span class="mt-1.5 text-md font-medium flex items-center gap-2">
                {{ user?.name }}
                @if (user?.opc_is_pro) {
                    <span class="pro-badge-inline">PRO</span>
                }
            </span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    @if (user?.opc_is_pro) {
        <button mat-menu-item (click)="goToPro()" class="pro-menu-item">
            <mat-icon [svgIcon]="'heroicons_outline:star'"></mat-icon>
            <span class="font-medium">{{ 'userMenu.mySubscription' | transloco }}</span>
        </button>
        <mat-divider class="my-2"></mat-divider>
    } @else {
        <button mat-menu-item (click)="goToPro()" class="pro-menu-item">
            <mat-icon [svgIcon]="'heroicons_outline:star'"></mat-icon>
            <span class="font-medium">{{ 'userMenu.getPro' | transloco }}</span>
        </button>
        <mat-divider class="my-2"></mat-divider>
    }
    <button mat-menu-item (click)="goToProfile()">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>{{ 'userMenu.myProfile' | transloco }}</span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
        ></mat-icon>
        <span>{{ 'userMenu.signOut' | transloco }}</span>
    </button>
</mat-menu>
